import { TRACK_TYPE_FINISHED, TRACK_TYPE_REVIEW } from '../../../constants'
import { getObjProperty } from '../../../helpers'
import { translate } from '../../../helpers/translations/translator'

export function getTrackSatisfactionTooltip(track: any, canViewSatisfactionFeedback = false) {
    if (! track.feedback) {
        return null
    }

    const remark = getObjProperty(track, 'feedback.remark')

    if (remark && canViewSatisfactionFeedback) {
        return remark
    }

    return translate(`pages.tracks.${getObjProperty(track, 'feedback.rating') && getObjProperty(track, 'feedback.rating').toLowerCase()}`)
}

export function getTrackAssessorTooltip(track: any) {
    if (! track.assessor) {
        return null
    }

    return `${translate('pages.tracks.approvedBy')} ${track.assessor}`
}

export function getEditTrackFormTitle(editTrackType: string): string {
    if (editTrackType === TRACK_TYPE_REVIEW) {
        return translate('pages.tracks.editTrackAndApprove')
    }

    if (editTrackType === TRACK_TYPE_FINISHED) {
        return translate('pages.tracks.editTrack')
    }

    return translate('pages.tracks.stopTrack')
}
